import { useActiveAccount } from '..';

export default function HideFromTypes({ types, children }) {
  const { hideFromTypes } = useActiveAccount();

  return hideFromTypes(types) ? null : children;
}
